<template>
	<div class="bg-struct bg-struct-details bg-img bg-img-19"></div>
	<div class="main-cont">
		<div id="project-sec" class="mb-5">&nbsp;</div>
		<section class="project-sec">
			<div class="d-flex justify-content-between mb-3">
				<h4 style="z-index: 1;">Изменение категории портфолио</h4>
				<div class="btn-group ms-1" role="group" v-if="authModel.isAdmin()">
					<router-link :to="{path: '/admin/works-categories'}" class="btn btn-secondary">
						<font-awesome-icon :icon="['fas', 'chevron-left']" />
						<span class="ms-2">Назад</span>
					</router-link>
				</div>
			</div>
			<div class="card border-0 shadow-sm text-center" v-if="loading">
				<div class="card-body py-4">
					<loading-spinner color="white" text="ЗАГРУЗКА..." />
				</div>
			</div>
			<div class="card border-0 shadow-sm text-center"  v-if="!loading && !workscat">
				<div class="card-body py-4">
					<h1>ЗАПИСЬ НЕ НАЙДЕНА</h1>
					<div class="mt-4">
						<router-link :to="{path: '/admin/works-categories'}" class="btn btn-secondary">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
							<span class="ms-2">Назад</span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="card border-0 shadow-sm" v-if="!loading && workscat">
				<form role="form" @submit.prevent="onEdit()">
					<div class="card-body">
						<div class="mb-3">
							<label class="form-label">ID</label>
							<input type="text" class="form-control" :value="workscat.id" readonly disabled />
						</div>
						<div class="mb-3">
							<label for="workscatName" class="form-label">Название <span class="text-danger">*</span></label>
							<input type="text" class="form-control" ref="name" id="workscatName" v-model="workscat.name" required autofocus />
						</div>
					</div>
					<div class="card-footer">
						<div class="d-grid gap-2 d-md-block text-center">
							<button type="submit" class="btn btn-primary">
								<font-awesome-icon :icon="['far', 'floppy-disk']" />
								<span class="ms-2">Сохранить</span>
							</button>
							<button type="button" class="btn btn-danger ms-md-2" @click="onDelete()">
								<font-awesome-icon :icon="['fas', 'trash-can']" />
								<span class="ms-2">Удалить</span>
							</button>
						</div>
					</div>
					<div class="card-body" v-if="error">
						<div class="alert alert-warning alert-dismissible mb-0" role="alert">
							{{error}}
							<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
						</div>
					</div>
				</form>
			</div>
		</section>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
	name: "AdminWorksCategoriesEdit",
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Изменение категории портфолио | Админ-панель | byLex Portfolio'});
	},
	data: () => ({
		workscat: {},
		
		loading: true,
		error: '',
	}),
	computed: {},
	methods: {
		async loadData(){
			this.error = '';
			let ret = await this.appModel.doGetWorksCategory(this.$route.params.id);
			this.workscat = ret.item;
		},
		
		async onEdit(){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doEditWorksCategory(this.$route.params.id, {
				name: this.workscat.name,
			});
			if(!ret.success){
				this.error = ret.message;
			}
			this.loading = false;
		},
		async onDelete(){
			if(confirm('Вы уверены?')){
				this.loading = true;
				let ret = await this.appModel.doDeleteWorksCategory(this.$route.params.id);
				if(ret.success){
					this.$router.push({path: '/admin/works-categories'});
				} else {
					this.error = ret.message;
				}
				this.loading = false;
			}
		},
	},
	async mounted(){
		this.loading = true;
		await this.loadData();
		this.loading = false;
		window.scrollTo(0, 0);
	},
	components: {
		LoadingSpinner,
	},
}
</script>
